import { useApiConfig, postJson } from '../../../composables/useApi';
import type { ApiConfig } from '../../../composables/useApi';
import type { OfferDto, OfferFormData, OfferImage } from '../types/offer.types';

export const offersApi = {
  listWithConfig: async (api: ApiConfig, params: Record<string, any>) => {
    return postJson<{ data: OfferDto[] }>(api.apiList, params);
  },
  listArchivedWithConfig: async (api: ApiConfig, params: Record<string, any>) => {
    const url = api.apiListArchived || api.apiList; // fallback just in case
    return postJson<{ data: OfferDto[] }>(url, params);
  },
  createWithConfig: async (api: ApiConfig, data: OfferFormData) => {
    return postJson<{ data: OfferDto }>(api.apiCreate, data);
  },
  updateWithConfig: async (api: ApiConfig, id: number, data: Partial<OfferFormData> & { images?: OfferImage[] }) => {
    return postJson<{ data: OfferDto }>(api.apiUpdate, { id, ...data });
  },
  uploadImageWithConfig: async (api: ApiConfig, offerId: number, file: File, position: number, is_cover: boolean) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('offerId', String(offerId));
    fd.append('position', String(position));
    fd.append('is_cover', is_cover ? '1' : '0');
    return fetch(api.apiUploadImage, {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
    }).then(r => r.json());
  },
  // Backward-compatible helpers using inject (only safe if called inside component setup)
  list: async (params: Record<string, any>) => {
    const api = useApiConfig();
    return postJson<{ data: OfferDto[] }>(api.apiList, params);
  },
  deleteWithConfig: async (api: ApiConfig, id: number) => {
    // Server accepts POST with id to delete
    return postJson<{ data: { id: number } }>(api.apiDelete, { id });
  },
  create: async (data: OfferFormData) => {
    const api = useApiConfig();
    return postJson<{ data: OfferDto }>(api.apiCreate, data);
  },
  update: async (id: number, data: Partial<OfferFormData> & { images?: OfferImage[] }) => {
    const api = useApiConfig();
    return postJson<{ data: OfferDto }>(api.apiUpdate, { id, ...data });
  },
  uploadImage: async (offerId: number, file: File, position: number, is_cover: boolean) => {
    const api = useApiConfig();
    return offersApi.uploadImageWithConfig(api, offerId, file, position, is_cover);
  },
};
